/**
 * Personalized health journey accordion
 * Extends theme accordion .active pattern with single-open behavior
 */
(function () {
  function closeItem(item) {
    var trigger = item.querySelector('[data-phj-accordion-trigger]');
    var panel = item.querySelector('[data-phj-accordion-panel]');

    if (!trigger || !panel) return;

    item.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.classList.remove('active');
    panel.setAttribute('hidden', '');
  }

  function openItem(item) {
    var trigger = item.querySelector('[data-phj-accordion-trigger]');
    var panel = item.querySelector('[data-phj-accordion-panel]');

    if (!trigger || !panel) return;

    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.classList.add('active');
    panel.removeAttribute('hidden');
  }

  function initAccordion(container) {
    var items = container.querySelectorAll('[data-phj-accordion-item]');

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-phj-accordion-trigger]');

      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        items.forEach(closeItem);

        if (!isOpen) {
          openItem(item);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-phj-accordion]').forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var accordion = event.target.querySelector('[data-phj-accordion]');
    if (accordion) initAccordion(accordion);
  });
})();
